import moment from 'moment-timezone';
import { timeZones } from 'const';

export default {
  tryGuessTZ: () => {
    const tz = moment.tz.guess();
    return timeZones.includes(tz) ? tz : '';
  },
};
